shadow$provide[26] = function(global,require,module,exports) {
module.exports=(pt_ts);
};